import { useEffect, useState } from "react"
import {
  Inventory2Outlined as Inventory2OutlinedIcon,
  Lock as LockIcon,
} from "@mui/icons-material"
import { Alert, AlertTitle } from "@mui/material"

import ProductsTable from "./ProductsTable"
import ProductsModal from "./ProductsModal"
import DeleteProductModal from "./DeleteProductModal"
import { useProductsAndServices } from "./useProductsAndServices"
import { getProductsAndServicesConfig } from "../../../services/settings-config"
import { getEnterprise } from "../../../services/scout"
import { isAccountBlocked, renderAIFeatures } from "../../../services/utils"

const ProductsPage = () => {
  const {
    items,
    editing,
    deleting,
    setEditing,
    setDeleting,
    save,
    remove,
  } = useProductsAndServices()

  const [enterprise, setEnterprise] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [shouldRenderContent, setShouldRenderContent] = useState(true)

  const isBlocked = isAccountBlocked(enterprise)

  useEffect(() => {
    const loadEnterprise = async () => {
      const data = await getEnterprise()
      setEnterprise(data)
      setShouldRenderContent(renderAIFeatures(data))
    }

    void loadEnterprise()
  }, [])

  const config = getProductsAndServicesConfig()

  const handleEdit = (item) => {
    if (isBlocked) return
    setEditing(item)
    setShowModal(true)
  }

  const handleAdd = () => {
    if (isBlocked) return
    setEditing(null)
    setShowModal(true)
  }

  const handleDelete = (item) => {
    if (isBlocked) return
    setDeleting(item)
  }

  const handleSave = async (payload) => {
    if (isBlocked) return false
    const ok = await save(payload)
    if (ok) {
      setShowModal(false)
      setEditing(null)
    }
    return ok
  }

  const handleRemove = async (item) => {
    if (isBlocked) return false
    const ok = await remove(item)
    if (ok) {
      setDeleting(null)
    }
    return ok
  }

  return (
    <>
      {shouldRenderContent
        ? <section className="scout-settings-section">
          <div className="scout-settings-section__label">
            <Inventory2OutlinedIcon />
            <span>{config?.sectionLabel || "Cardápio de produtos e serviços"}</span>
          </div>

          <Alert severity="info" style={{ marginBottom: 16 }}>
            <AlertTitle>
              Para saber como utilizar o cardápio de produtos e serviços{' '}
              <a
                href="https://instant.getoutline.com/s/81dbbdb2-7b97-4d51-b79a-77499d8e4341#h-produtos-e-servicos"
                target="_blank"
                rel="noreferrer"
                className="scout-settings-link-dark"
              >
                clique aqui
              </a>
              .
            </AlertTitle>
          </Alert>

          <ProductsTable
            items={items}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onAdd={handleAdd}
            disabled={isBlocked}
          />
        </section>
        : <Alert severity="info" icon={<LockIcon fontSize="inherit" />}>
          <AlertTitle>Recurso indisponível no seu plano.</AlertTitle>
        </Alert>
      }

      {showModal && !isBlocked ? (
        <ProductsModal
          open={showModal}
          onClose={() => {
            setShowModal(false)
            setEditing(null)
          }}
          initialValue={editing}
          onSubmit={handleSave}
          submitLabel={editing ? "Salvar" : "Criar"}
        />
      ) : null}

      {!isBlocked ? (
        <DeleteProductModal
          open={Boolean(deleting)}
          item={deleting}
          onClose={() => setDeleting(null)}
          onConfirm={handleRemove}
        />
      ) : null}
    </>
  )
}

export default ProductsPage
